<template>
  <div class="text-white track-count">
    <div class="flex mb-9">
      <div
        v-for="inactiveTrack in campaignTrackNormalMin"
        :class="inactiveTrack === 1 ? '' : 'ml-3'"
        :key="'active' + inactiveTrack"
        class="flex-1 h-2 relative rounded-lg bg-gray-400 overflow-hidden"
      >
        <span
          :class="
            inactiveTrack <= campaignTrackIdsSelected.length
              ? 'scale-x-1'
              : 'scale-x-0'
          "
          class="
            w-full
            h-10
            block
            absolute
            ease-in-out
            transform
            origin-left
            transition
            duration-300
            top-0
            left-0
          "
          :style="{ background: themePrimaryColor }"
        >
        </span>
      </div>
    </div>
    <div class="text-base mb-9 text-center font-medium">
      {{
        $t("searchTracksChoose").replace("{total}", campaignTrackNormalMin.toString())
      }}
    </div>
    <div class="text-xs text-center">
      {{
        $t("searchTracksChosen")
          .replace("{count}", campaignTrackIdsSelected.length.toString())
          .replace("{total}", campaignTrackNormalMin.toString())
      }}
    </div>
  </div>
</template>

<script lang="ts">
import { TranslationHandler } from '../../mixins/translation-handler'
import { Mixins, Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({})
export default class TrackCount extends Mixins(TranslationHandler) {
  @Getter campaignTrackIdsSelected!: string[]
  @Getter themePrimaryColor!: string
  @Getter campaignTrackNormalMin!: number
}
</script>
